@if (injuryGroups) { @for (seasonData of injuryGroups['seasons']; track $index; let i = $index) { @for
(subtournamentData of seasonData['subtournaments']; track $index; let j = $index) {
<h4 class="head mt-2 ml-2 ml-xl-0">
    {{ seasonData['tournament']['name'] }}, {{ seasonData['season']['name'] }},
    {{ subtournamentData['subtournament']['name'] }}
</h4>
<div class="d-flex table-scrollable">
    <div class="table-scrollable__data flex-grow-1">
        <table class="table-scrollable__data__table" data-cy="app-table-left-data">
            <thead>
                <tr>
                    <th class="table-scrollable__table-th">
                        {{ 'web.week' | translate }}
                    </th>
                    <th class="table-scrollable__table-th">
                        {{ 'web.injury' | translate }}
                    </th>
                    <th class="table-scrollable__table-th">
                        {{ 'web.status' | translate }}
                    </th>
                    <th class="table-scrollable__table-th">
                        {{ 'web.practice_status' | translate }}
                    </th>
                </tr>
            </thead>
            <tbody>
                @for (weekData of subtournamentData['weeks']; track $index; let k = $index) { @if (weekData['injuries']
                !== null) { @for (injuryData of weekData['injuries']; track $index) {
                <tr class="table-scrollable__table-row">
                    <td class="table-scrollable__table-td w-25">
                        {{ weekData['week']['name'] ?? 'Week ' + weekData['week']['number'] }}
                    </td>
                    <td class="table-scrollable__table-td w-25">
                        {{ injuryData.primary }}@if (injuryData.secondary !== null) { , {{ injuryData.secondary }}
                        }
                    </td>
                    <td class="table-scrollable__table-td w-25">
                        {{ injuryData.status }}
                    </td>
                    <td class="table-scrollable__table-td">
                        {{ injuryData.practice_status }}
                    </td>
                </tr>
                } } @else {
                <app-placeholder-match></app-placeholder-match>
                } }
            </tbody>
        </table>
    </div>
</div>
} } } @else {
<app-placeholder-table></app-placeholder-table>
} @if (injuryGroups?.seasons.length === 0) {
<div class="text-center">
    <strong>{{ 'web.no_data_found' | translate }}</strong>
</div>
}
